<template>
	<div class="about">
		<img class="wow fadeIn" style="width: 100%;" src="../../assets/seeBg.jpg" />
		<div class="mainArea ">
			<div class="threeGod2 wow bounceInUp">
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/20260316/1.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">ATEEZ「LIGHT THE WAY」沉浸式特展，解锁全新粉丝体验</div>
						<div class="info">继成功落地 TOMORROW X TOGETHER（以下简称 TXT）专属沉浸式VR体验特展 之后，橙猩 VR 与全球顶尖沉浸式内容机构 AMAZE 再度携手，为中国粉丝带来了全新重磅体验 ——ATEEZ「LIGHT THE WAY」沉浸式特展</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20260316)">阅读全文 ></div>
							<div class="b">发布时间：2026-03-16</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20260122.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">橙猩 VR×AMAZE 重磅联动！TXT 沉浸式VR体验特展全国燃启</div>
						<div class="info">当顶流 K-POP 团体遇上沉浸式VR黑科技，一场跨越时空的沉浸式狂欢正式登陆！</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20260122)">阅读全文 ></div>
							<div class="b">发布时间：2026-01-22</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251226.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">打造文化新质生产力样本：虚拟现实电影《木兰2125》首映式暨专家座谈会在上海国际传媒港举行</div>
						<div class="info">12月25日，虚拟现实电影《木兰2125》首映式暨专家座谈会在上海国际传媒港CMG融媒影城隆重举行。本次活动由天下票仓(上海)网络科技有限公司主办，湖南欧音文化传媒有限公司联合主办，上海橙猩数字娱乐科技有限公司承办。 </div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251226)">阅读全文 ></div>
							<div class="b">发布时间：2025-12-26</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251212.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">运用优质内容和创新科技重塑娱乐消费体验：天下票仓官网全新改版，庆祝公司混改完成六周年暨新厂牌“橙猩”启动四周年</div>
						<div class="info">日前，橙猩母公司天下票仓（上海）网络信息科技有限公司（“天下票仓”）推出全新改版的官方网站——http:www.txpc.cn。 </div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251212)">阅读全文 ></div>
							<div class="b">发布时间：2025-12-12</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251204.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">Dreamcatcher VR演唱会登陆橙猩VR影院，沉浸式解锁偶像舞台！</div>
						<div class="info">当 K-pop 舞台与 VR 技术碰撞，当影院场景与沉浸体验融合，一场打破时空边界的音乐盛宴即将来袭！近日，人气韩团 Dreamcatcher 专属 VR 演唱会正式登陆橙猩180°VR影院，全国各大门店同步上线，为粉丝打造 “置身舞台中央” 的专属观演体验，重新定义偶像演唱会的打开方式。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goOut('poGDjo37p1cZVE8EdNHC6g')">阅读全文 ></div>
							<div class="b">发布时间：2025-12-04</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251113.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">橙猩 VR × 博纳电影院线完成战略签约，以 VR 之力重构影院价值</div>
						<div class="info">当观众对 “坐在影厅看电影” 的传统模式逐渐产生审美疲劳，当影院经营者为非票业务增长乏力而寻求突破，一场关于 “影院空间价值重构” 的变革正在悄然发生。近日，橙猩 VR 与博纳电影院线的完成战略签约，为这场变革给出了全新答案 —— 双方将通过 VR 技术与影院场景的深度融合，打造 “观影 + 沉浸体验” 的双业态消费模式，让影院从 “电影放映载体” 升级为 “多元娱乐目的地”。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251113)">阅读全文 ></div>
							<div class="b">发布时间：2025-11-13</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251104.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">橙猩 VR × 大麦：试映交流会成功举行，沉浸式娱乐新场景引期待</div>
						<div class="info">近日，橙猩 VR 受邀走进阿里巴巴园区，面向其内部核心人员举办专属 180°VR 试映交流会。此次活动通过沉浸式内容体验、产品优势解析与合作方向探讨，全方位展示橙猩 VR 在 LBE（Location-Based Entertainment）领域的创新成果，为双方后续深度联动搭建坚实桥梁，更让行业看到 VR 技术与文娱场景融合的广阔可能。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251104)">阅读全文 ></div>
							<div class="b">发布时间：2025-11-04</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251028.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">橙猩 VR× 卢米埃：双方协同破局，重塑影院沉浸式体验产业格局</div>
						<div class="info">当传统影院仍在存量空间激活与坪效提升的赛道上探索，沉浸式体验已成为突破行业增长瓶颈的核心变量。近日，橙猩 VR 与卢米埃影城正式达成战略合作并举办签约仪式，双方以 “技术筑基、场景赋能、内容落地” 为核心逻辑，构建起覆盖硬件供给、场地运营、内容运营的全链条合作体系，共同探索沉浸式观影的全新发展路径。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251028)">阅读全文 ></div>
							<div class="b">发布时间：2025-10-28</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251014.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">影院VR的生态阳谋：天下票仓如何从“卖票”到“组局”，定义LBE下半场的坪效革命与行业新基建</div>
						<div class="info">先看一组统计数据：2024年中国电影总票房425亿元，总放映场次1.42亿，总观影人次10.1亿；以此推算，场均票房约为300元，场均人次约为7人。同年，中国在运营的影院约13,300家，影厅总数约81,000个，位居全球第一</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251014)">阅读全文 ></div>
							<div class="b">发布时间：2025-10-14</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20251009.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">VR体验 | 如何点燃体验经济的“感官革命”</div>
						<div class="info">在数字技术浪潮的推动下，虚拟现实（VR）技术正以颠覆性的力量重构人类与数字世界的交互方式。从早期实验室中的概念雏形到如今渗透至文旅、教育、医疗、工业等领域的成熟应用，VR科技不仅突破了物理空间的限制，更通过“沉浸感”与“交互性”的双重革新，重新定义了“体验”的本质。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20251009)">阅读全文 ></div>
							<div class="b">发布时间：2025-10-09</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20250824.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">中国首部3A级VR沉浸式电影《木兰2125》媒体看片会圆满举办</div>
						<div class="info">中国首部3A级VR沉浸式电影《木兰2125》在上海开展内部试看会，本次看片聚焦作品优化与意见收集，旨在通过核心团队、行业伙伴的提前品鉴，为影片后续打磨提供方向。这部由实时云渲染头部企业蔚领时代研发、橙猩数娱联合推广的XR影视作品，凭借其突破性的技术架构与东方科幻叙事，成为全球沉浸式内容领域的焦点。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20250824)">阅读全文 ></div>
							<div class="b">发布时间：2025-08-24</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20250725.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">VR演唱会 | 科技重构娱乐产业新生态</div>
						<div class="info">虚拟现实技术正以颠覆性姿态重塑音乐产业，从突破物理边界的演出形态革新，到重构商业逻辑的生态体系进化，其影响力正以燎原之势蔓延至整个娱乐业。从 李玟 “千禧之境”虚拟演唱会，首次尝试集6DoF体验、全虚拟场景和实时动捕技术于一体，到K-Pop艺人车银优通过VR技术实现全球21个国家和地区“巡演”——它标志着娱乐业在 21 世纪的“第二次地理大发现”：舞台的边界消失了，但产业的疆土正在指数级扩张。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20250725)">阅读全文 ></div>
							<div class="b">发布时间：2025-07-25</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20250704.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">车银优 VR 演唱会|上海场惊喜即将来袭</div>
						<div class="info">当 180°VR 技术叩响娱乐体验的新大门，一场颠覆想象的感官革命正悄然降临。它以独特的视角张力打破传统屏幕的束缚，让虚拟与现实的边界变得模糊，将观众从被动的观看者转变为沉浸式体验的核心参与者。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20250704)">阅读全文 ></div>
							<div class="b">发布时间：2025-07-04</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20250702.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">橙猩180°VR受邀参加2025江南电影大会</div>
						<div class="info">6 月 27 日，以 “融合创新 光影未来” 为主题的 2025 江南电影大会在苏州相城盛大启幕。450 余位电影行业精英、技术专家及文化界代表齐聚一堂，共探电影产业创新路径，深化区域文化协作。在这场电影行业的盛会中，上海橙猩数字娱乐总经理牛朝野携旗下创新项目 “橙猩 180°VR 剧场” 惊艳亮相，瞬间成为全场焦点，吸引了众多与会者的目光。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20250702)">阅读全文 ></div>
							<div class="b">发布时间：2025-07-02</div>
						</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="itemBox_b" ref="itemBox_bref">
						<img class="itemBox_bimg" src="../../assets/seeList/20250626.jpg"  />
					</div>
					<div class="itemBox_a">
						<div class="title">VR沉浸式|变革浪潮下的创新实践与未来图景</div>
						<div class="info">在当今科技迅猛发展的时代，VR 行业正以前所未有的态势重塑着人们的生活与娱乐体验。从繁华商场中的奇妙体验，到广阔大空间里的沉浸式冒险，再到校园中创新的 VR 教学以及影厅里震撼的 VR 明星演唱会，虚拟现实（VR）技术正以颠覆性姿态重塑商业、教育、文旅及娱乐产业的底层逻辑。这场技术革命已突破单一场景限制，构建起覆盖全产业链的虚实共生生态。</div>
						<div class="bottom flexBtw">
							<div class="a" @click="goto(20250626)">阅读全文 ></div>
							<div class="b">发布时间：2025-06-26</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'See',
		data() {
			return {
				mheight:'',
				menuShow:true,
				toten:''
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.$router.push({ path: '/mobile/see'});
			}
		},
		mounted() {
			if(window.innerWidth<=800){
				this.menuShow=false
			}
			const divWidth = this.$refs.itemBox_bref.offsetWidth;
			this.mheight=410*divWidth/570+'px'
			this.$nextTick(() => {
				
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		},
		methods:{
			goto(type){
				this.$router.push({ path: '/pc/seeInfo?type='+type});
			},
			goOut(id){
				window.location.href='https://mp.weixin.qq.com/s/'+id
			},
			// getAccessToken() {
			//   const response = await fetch('https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=wx32538de9739aa8df&secret=60c5b4d5efb2569fd17c7e045424d7dd');
			//   const data = await response.json();
			// 	console.log('111',data.access_token)
			//   this.toten= data.access_token;
			// },
			// getArticleList(accessToken) {
			//   const response = await fetch(`https://api.weixin.qq.com/cgi-bin/material/batchget_material?access_token=${accessToken}`);
			//   const data = await response.json();
			//   return data.news_item; // 返回文章列表
			// },
			// getArticleDetail(accessToken, mediaId) {
			//   const response = await fetch(`https://api.weixin.qq.com/cgi-bin/material/get_material?access_token=${accessToken}&media_id=${mediaId}`);
			//   const data = await response.json();
			//   return data; // 返回文章详情
			// }
		}
	}
</script>
<style lang="less" scoped>
	.threeGod {
		margin: 50px auto;
		width: 1000px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		img {
			margin-bottom: 20px;
		}
	}
	.lightBox{
		position: relative;
		overflow: hidden;
		padding-bottom: 80px;
	}
	.light-1 {
		position: absolute;
		z-index: 0;
		width: 1000px;
		height: 1000px;
		border-radius: 50%;
		filter: blur(80px);
		animation: moveAround 10s linear infinite;
		background: rgba(106, 0, 255, 0.4);
		top: 10px;
		left: calc(50% - 500px);
		animation-delay: 0s;
	}
	.itemBox{
		display: flex;
		align-items: center;
		background: #fff;
		justify-content: space-between;
		margin-bottom: 30px;		
		.itemBox_a{
			flex-shrink: 0;			
			width: 60%;
			padding: 40px;
			text-align: left;
			.title{
				color: #000;
				font-size: 30px;
				margin-bottom: 10px;
			}
			.info{
				line-height: 30px;
				color: #777;
				font-size: 16px;
			}
			.bottom{
				margin-top: 30px;
				.a{
					background: #FB5400;
					color: #fff;
					font-size: 20px;
					line-height: 50px;
					padding-left: 20px;
					padding-right: 20px;
					cursor: pointer;
					border-radius:2px;
				}
				.b{
					font-size: 12px;
					color: #999;
				}
			}
		}
		.itemBox_b{
			width: 40%;
			padding: 20px 0 20px 20px;
			.itemBox_bBox{
				height: 800px;
			}
			.itemBox_bimg{
				width: 100%;
				height: auto;
				background: darkblue;
			}
		}
	}
	.threeGod2 {
		position: relative;
		padding-top: 30px;
		border-top: 1px solid #333;
		font-size: 30px;
		background: url('../../assets/Polygon 1.png') no-repeat top center;
		background-size: 100% auto;

		.a {
			line-height: 80px;
		}

		.b {
			color: #FB5400;
		}
	}

	@media (max-width:1440px) {
		.threeGod {
			margin-top: 80px;
			width: 500px;
		}
		
		.itemBox{
			.itemBox_a{
				.title{
					font-size: 20px;
				}
				.info{
					font-size: 14px;
				}
			}
		}
	}
	@media (max-width:800px) {
		.threeGod {
			margin-top: 50px;
			width: 300px;
			font-size: 14px;
			img{
				height: 30px;
			}
		}
		.threeGod2 {
			.a {
				font-size: 24px;
				line-height: 50px;
			}
		}
		.itemBox{
			display: block;
			.itemBox_a{
				width: 100%;
				padding: 20px;
				.bottom{
					margin-top: 10px;
					.a{
						font-size: 18px;
						line-height: 30px;
					}					
				}
			}
			.itemBox_b{
				width: 100%;
				padding: 20px;
				.itemBox_bBox{
					height: 800px;
				}
			}
		}
	}
</style>